export default __webpack_public_path__ + "static/media/Poppins-SemiBold.ec09da72.ttf";